export default class Investors {
    constructor() {

        const resultsButton = document.querySelector('#investors .results');
        const adviseButton = document.querySelector('#investors .advise');
        const contentResult = document.getElementById('content-result');
        const contentAdvise = document.getElementById('content-advise');

        function activateContent(contentToShow) {
            if (contentToShow.classList.contains('active')) {
                contentToShow.classList.remove('active');
                return;
            }

            contentResult.classList.remove('active');
            contentAdvise.classList.remove('active');

            contentToShow.classList.add('active');
        }

        const firstTab = document.querySelector('.investors #toggleButton1');
        const secondTab = document.querySelector('.investors #toggleButton2');
        const secondContent = document.querySelector('.investors .content:last-of-type');
        secondTab.classList.add('active');
        secondContent.classList.add('active');

        resultsButton.addEventListener('click', () => {
            activateContent(contentResult);
            contentAdvise.classList.remove('active');

            secondTab.classList.remove('active');
            if (firstTab.classList.contains('active')) {
                firstTab.classList.remove('active');
            } else {
                firstTab.classList.add('active');
            }
        });

        adviseButton.addEventListener('click', () => {
            activateContent(contentAdvise);
            contentResult.classList.remove('active');

            firstTab.classList.remove('active');
            if (secondTab.classList.contains('active')) {
                secondTab.classList.remove('active');
            } else {
                secondTab.classList.add('active');
            }
        });

        function populateSelectOptions(selectId, className) {
            const selectElement = document.getElementById(selectId);
            if (!selectElement) return;

            const options = new Set();
            const items = document.querySelectorAll(`.${className}`);
            items.forEach(item => {
                const optionText = item.textContent.trim();
                if (!options.has(optionText)) {
                    options.add(optionText);
                    const optionElement = document.createElement('option');
                    optionElement.textContent = optionText;
                    optionElement.value = optionText;
                    selectElement.appendChild(optionElement);
                }
            });
        }

        populateSelectOptions('filter-safra', 'harvest');
        populateSelectOptions('filter-quarter', 'quarter');
        populateSelectOptions('filter-subject', 'subject');
        populateSelectOptions('filter-year', 'year');

        function filterResults() {
            const safraFilter = document.getElementById('filter-safra').value;
            const quarterFilter = document.getElementById('filter-quarter').value;
            const subjectFilter = document.getElementById('filter-subject').value;
            const normalItems = document.querySelectorAll('.normal-item');
            const noResultsMsg = document.getElementById('no-results-msg');
            let hasResults = false;

            normalItems.forEach(item => {
                const harvest = item.querySelector('.harvest').textContent.trim();
                const quarter = item.querySelector('.quarter').textContent.trim();
                const subject = item.querySelector('.subject').textContent.trim();
                const showItem = (!safraFilter || safraFilter === harvest) &&
                                 (!quarterFilter || quarterFilter === quarter) &&
                                 (!subjectFilter || subjectFilter === subject);

                item.style.display = showItem ? 'flex' : 'none';
                if (showItem) hasResults = true;
            });

            noResultsMsg.style.display = hasResults ? 'none' : 'flex';
            showItems(currentPage); // Atualiza a exibição com a página atual
        }

        function resetFilterIfEmpty(selectId) {
            const selectElement = document.getElementById(selectId);
            if (selectElement && selectElement.value === '') {
                filterResults(); // Atualiza a visualização após resetar o filtro
            }
        }

        document.getElementById('filter-safra').addEventListener('change', () => {
            filterResults();
            resetFilterIfEmpty('filter-safra');
        });

        document.getElementById('filter-quarter').addEventListener('change', () => {
            filterResults();
            resetFilterIfEmpty('filter-quarter');
        });

        document.getElementById('filter-subject').addEventListener('change', () => {
            filterResults();
            resetFilterIfEmpty('filter-subject');
        });

        function showItems(page) {
            const filteredItems = getFilteredItems();
            const totalItems = filteredItems.length;
            const totalPages = Math.ceil(totalItems / itemsPerPage);
            const startIndex = (page - 1) * itemsPerPage;
            const endIndex = startIndex + itemsPerPage;

            document.querySelectorAll('.normal-item').forEach(item => item.style.display = 'none');
            filteredItems.slice(startIndex, endIndex).forEach(item => item.style.display = 'flex');

            updatePaginationInfo(page, totalPages);
        }

        function updatePaginationInfo(currentPage, totalPages) {
            const paginationContainer = document.getElementById('pagination');
            paginationContainer.innerHTML = '';

            if (totalPages > 1) {
                paginationContainer.style.display = 'flex';
                if (currentPage > 1) {
                    const prevButton = document.createElement('button');
                    prevButton.textContent = '<';
                    prevButton.id = 'prev-page';
                    prevButton.className = 'pagination-btn';
                    prevButton.addEventListener('click', () => {
                        if (currentPage > 1) {
                            currentPage--;
                            showItems(currentPage);
                        }
                    });
                    paginationContainer.appendChild(prevButton);
                }

                if (totalPages <= 3) {
                    for (let i = 1; i <= totalPages; i++) {
                        createPageButton(i);
                    }
                } else {
                    createPageButton(1);

                    if (currentPage > 3) {
                        paginationContainer.appendChild(createEllipsis());
                    }

                    const startPage = Math.max(currentPage - 1, 2);
                    const endPage = Math.min(currentPage + 1, totalPages - 1);

                    for (let i = startPage; i <= endPage; i++) {
                        createPageButton(i);
                    }

                    if (currentPage < totalPages - 2) {
                        paginationContainer.appendChild(createEllipsis());
                    }

                    createPageButton(totalPages);
                }

                if (currentPage < totalPages) {
                    const nextButton = document.createElement('button');
                    nextButton.textContent = '>';
                    nextButton.id = 'next-page';
                    nextButton.className = 'pagination-btn';
                    nextButton.addEventListener('click', () => {
                        if (currentPage < totalPages) {
                            currentPage++;
                            showItems(currentPage);
                        }
                    });
                    paginationContainer.appendChild(nextButton);
                }
            } else {
                paginationContainer.style.display = 'none';
            }

            function createPageButton(pageNumber) {
                const pageButton = document.createElement('button');
                pageButton.textContent = pageNumber;
                pageButton.classList.add('page-button');
                pageButton.classList.add('pagination-btn');

                if (pageNumber === currentPage) {
                    pageButton.classList.add('active');
                } else {
                    pageButton.addEventListener('click', () => {
                        currentPage = pageNumber;
                        showItems(currentPage);
                    });
                }
                paginationContainer.appendChild(pageButton);
            }

            function createEllipsis() {
                const ellipsis = document.createElement('span');
                ellipsis.textContent = '...';
                ellipsis.classList.add('ellipsis');
                return ellipsis;
            }
        }

        function getFilteredItems() {
            const selectedSafra = document.getElementById('filter-safra').value;
            const selectedQuarter = document.getElementById('filter-quarter').value;
            const selectedSubject = document.getElementById('filter-subject').value;
            const allNormalItems = document.querySelectorAll('.normal-item');
            return Array.from(allNormalItems).filter(item => {
                const safra = item.querySelector('.harvest').textContent;
                const quarter = item.querySelector('.quarter').textContent;
                const subject = item.querySelector('.subject').textContent;
                return (!selectedSafra || safra === selectedSafra) &&
                       (!selectedQuarter || quarter === selectedQuarter) &&
                       (!selectedSubject || subject === selectedSubject);
            });
        }

        const itemsPerPage = 5;
        let currentPage = 1;

        showItems(currentPage);

        const prevPageButton = document.getElementById('prev-page');
        const nextPageButton = document.getElementById('next-page');
        prevPageButton?.addEventListener('click', () => {
            if (currentPage > 1) {
                currentPage--;
                showItems(currentPage);
            }
        });
        nextPageButton?.addEventListener('click', () => {
            const filteredItems = getFilteredItems();
            const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
            if (currentPage < totalPages) {
                currentPage++;
                showItems(currentPage);
            }
        });

        if (document.getElementById('content-advise')) {
            this.initAdvisePagination();
        }
    }

    initAdvisePagination() {
        const itemsPerPage2 = 5;
        let currentPage2 = 1;

        const prevPageButton2 = document.getElementById('prev-page2');
        const nextPageButton2 = document.getElementById('next-page2');

        function showFilteredAdviseItems(page) {
            const filteredItems = getFilteredAdviseItems();
            const totalItems = filteredItems.length;
            const totalPages = Math.ceil(totalItems / itemsPerPage2);
            const startIndex = (page - 1) * itemsPerPage2;
            const endIndex = startIndex + itemsPerPage2;

            document.querySelectorAll('.advise-item').forEach(item => item.style.display = 'none');
            filteredItems.slice(startIndex, endIndex).forEach(item => item.style.display = 'flex');

            updateFilteredAdvisePaginationInfo(page, totalPages);
        }

        function updateFilteredAdvisePaginationInfo(currentPage2, totalPages) {
            const paginationContainer2 = document.getElementById('pagination2');
            paginationContainer2.innerHTML = '';

            if (totalPages > 1) {
                paginationContainer2.style.display = 'flex';
                if (currentPage2 > 1) {
                    const prevButton2 = document.createElement('button');
                    prevButton2.textContent = '<';
                    prevButton2.id = 'prev-page2';
                    prevButton2.className = 'pagination-btn';
                    prevButton2.addEventListener('click', () => {
                        if (currentPage2 > 1) {
                            currentPage2--;
                            showFilteredAdviseItems(currentPage2);
                        }
                    });
                    paginationContainer2.appendChild(prevButton2);
                }

                if (totalPages <= 3) {
                    for (let i = 1; i <= totalPages; i++) {
                        createPageButton2(i, paginationContainer2);
                    }
                } else {
                    createPageButton2(1, paginationContainer2);

                    if (currentPage2 > 3) {
                        paginationContainer2.appendChild(createEllipsis2());
                    }

                    const startPage = Math.max(currentPage2 - 1, 2);
                    const endPage = Math.min(currentPage2 + 1, totalPages - 1);

                    for (let i = startPage; i <= endPage; i++) {
                        createPageButton2(i, paginationContainer2);
                    }

                    if (currentPage2 < totalPages - 2) {
                        paginationContainer2.appendChild(createEllipsis2());
                    }

                    createPageButton2(totalPages, paginationContainer2);
                }

                if (currentPage2 < totalPages) {
                    const nextButton2 = document.createElement('button');
                    nextButton2.textContent = '>';
                    nextButton2.id = 'next-page2';
                    nextButton2.className = 'pagination-btn';
                    nextButton2.addEventListener('click', () => {
                        if (currentPage2 < totalPages) {
                            currentPage2++;
                            showFilteredAdviseItems(currentPage2);
                        }
                    });
                    paginationContainer2.appendChild(nextButton2);
                }
            } else {
                paginationContainer2.style.display = 'none';
            }

            function createPageButton2(pageNumber, container) {
                const pageButton2 = document.createElement('button');
                pageButton2.textContent = pageNumber;
                pageButton2.classList.add('page-button2');
                pageButton2.classList.add('pagination-btn');

                if (pageNumber === currentPage2) {
                    pageButton2.classList.add('active');
                } else {
                    pageButton2.addEventListener('click', () => {
                        currentPage2 = pageNumber;
                        showFilteredAdviseItems(currentPage2);
                    });
                }
                container.appendChild(pageButton2);
            }

            function createEllipsis2() {
                const ellipsis2 = document.createElement('span');
                ellipsis2.textContent = '...';
                ellipsis2.classList.add('ellipsis2');
                ellipsis2.classList.add('pagination-btn');
                return ellipsis2;
            }
        }

        function getFilteredAdviseItems() {
            const selectedYear = document.getElementById('filter-year').value;
            const allAdviseItems = document.querySelectorAll('.advise-item');
            return Array.from(allAdviseItems).filter(item => {
                const yearElement = item.querySelector('.year');
                const year = yearElement ? yearElement.textContent.trim() : '';
                return !selectedYear || year === selectedYear;
            });
        }

        document.getElementById('filter-year').addEventListener('change', () => {
            currentPage2 = 1;
            showFilteredAdviseItems(currentPage2);
        });

        showFilteredAdviseItems(currentPage2);

        prevPageButton2?.addEventListener('click', () => {
            if (currentPage2 > 1) {
                currentPage2--;
                showFilteredAdviseItems(currentPage2);
            }
        });

        nextPageButton2?.addEventListener('click', () => {
            const filteredItems = getFilteredAdviseItems();
            const totalPages = Math.ceil(filteredItems.length / itemsPerPage2);
            if (currentPage2 < totalPages) {
                currentPage2++;
                showFilteredAdviseItems(currentPage2);
            }
        });
    }
}
